/**
 * The main component that renders single TabComponent
 * instances.
 */

import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { TabPageComponent } from './tab-page.component';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-tab-control',
  template: `
    <nav class="tabs" [class.expand]="expand">
      <div
        *ngFor="let tab of tabs; let i = index"
        (click)="select(i)"
        [class.active]="tab.isActive"
      >
        {{ tab.tabName }}
      </div>
      <div class="last"></div>
    </nav>

    <div class="tab-pages">
      <i class="border-fix">&nbsp;</i>
      <ng-content> </ng-content>
    </div>
  `,
  styles: [
    `
      nav.tabs {
        display: flex;
      }

      nav.tabs > div {
        border: 1px solid #ccc;
        border-left: none;
        height: 36px;
        line-height: 36px;
        text-align: center;
        padding: 0.25em 0.5em;
        cursor: pointer;
      }

      nav.tabs > div:first-child {
        border-left: 1px solid #ccc;
      }

      nav.tabs > div:last-child {
        flex-grow: 1;
        border-right: none;
        border-top: none;
        margin-top: 1px;
        cursor: auto;
      }

      nav.tabs.expand > div {
        flex-grow: 1;
      }

      nav.tabs.expand > div:last-child {
        display: none;
      }

      nav.tabs > div.active {
        border-top: 2px solid red;
        border-bottom: none;
      }

      nav.tabs + div.tab-pages {
        border: 1px solid #ccc;
        border-top: none;
      }

      .border-fix {
        height: 0px;
        display: block;
      }
    `,
  ],
})
export class TabControlComponent {
  @Input()
  expand: boolean = false;

  @Output() tabClick: EventEmitter<any> = new EventEmitter<any>();

  tabs: TabPageComponent[] = [];
  selectedIndex: number = -1;

  addTab(tab: TabPageComponent): void {
    if (this.tabs.length === 0) {
      tab.isActive = true;
      this.selectedIndex = 0;
    }

    this.tabs.push(tab);
    console.log('TAB_', this.tabs);
  }

  select(tabIndex: number): void {
    if (this.canSwitchIndex(tabIndex)) {
      this.tabs[this.selectedIndex].isActive = false;
      this.tabs[tabIndex].isActive = true;
      this.selectedIndex = tabIndex;
      console.log('this.tabs[tabIndex].tabName', this.tabs[tabIndex].tabName);
      var obj = {
        index: tabIndex,
        name: this.tabs[tabIndex].tabName,
      };
      this.tabClick.emit(obj);
    }
  }

  private canSwitchIndex(newIndex: number): boolean {
    return (
      newIndex !== this.selectedIndex &&
      newIndex >= 0 &&
      newIndex < this.tabs.length
    );
  }

  // @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

  // // contentChildren are set
  // ngAfterContentInit() {
  //   // get all active tabs
  //   let activeTabs = this.tabs.filter((tab) => tab.active);

  //   // if there is no active tab set, activate the first
  //   if (activeTabs.length === 0) {
  //     this.selectTab(this.tabs?.first);
  //   }
  // }

  // selectTab(tab: any) {
  //   // deactivate all tabs
  //   this.tabs.toArray().forEach((tab) => (tab.active = false));

  //   // activate the tab the user has clicked on.
  //   tab.active = true;
  // }
}
